import * as React from 'react'
import OverlayLoading from '../Loading/OverlayLoading'

const Loading = (props: any) => {
  return <OverlayLoading show={props.loading} size={'60px'} />
}
export default Loading
